// extracted by mini-css-extract-plugin
export default {"details":"subscriptionsDetails_details__Zn6mt"};